<script setup>
import { onLaunch, onError, onUnhandledRejection } from '@dcloudio/uni-app'
import { useUserStore } from '@/store/user'

// [修复] 全局错误兜底，防止未捕获异常导致白屏
onError((err) => {
  console.error('[App Error]', err)
})

// [修复] 全局未处理 Promise 异常兜底
onUnhandledRejection((res) => {
  console.error('[App UnhandledRejection]', res.reason || res)
})

onLaunch(async () => {
  console.log('App Launch')
  const userStore = useUserStore()

  // [修复] 监听网络状态变化，断网时提示用户
  uni.onNetworkStatusChange((res) => {
    if (!res.isConnected) {
      uni.showToast({ title: '网络连接已断开', icon: 'none', duration: 2000 })
    }
  })

  if (userStore.isLoggedIn) {
    // 有 token（本地未过期）直接进主页；自动登录改由登录页「一键登录」按钮触发
    uni.reLaunch({ url: '/pages/index/index' })
  }
  // 无 token：登录页为首页（pages.json 首项），停留登录页由用户发起一键登录或手动登录
})
</script>

<style>
page {
  background-color: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}
</style>
